<template>
  <div>
    <div v-if="showContent" class="container-fluid mt-3">
      <div class="container-md">
        <div class="container-bg p-5">
          <div class="row">
            <div
              class="col-12 col-md-12 col-lg-6 mt-3"
              v-for="(committee, index) in committees"
              :key="'committee_' + index"
            >
              <div class="card">
                <div class="row no-gutters align-items-center pt-3 p-2">
                  <div class="col-auto">
                    <img
                      src="/android-chrome-512x512.png"
                      style="
                        width: 80px;
                        height: 80px;
                        border: 1px solid #ffffff;
                        border-radius: 50%;
                      "
                      class="img-fluid"
                      alt=""
                    />
                  </div>
                  <div class="col">
                    <div class="card-block px-2">
                      <h3 class="text-white text-uppercase">
                        {{ committee.title }}
                      </h3>
                      <p class="text-white" style="line-height: normal"></p>
                    </div>
                  </div>
                </div>
                <div class="card-footer w-100">
                  <div class="row align-items-center">
                    <div class="col-6 ml-2"></div>
                    <div class="col-5">
                      <a
                        :href="committee.id + '/view'"
                        class="btn btn-dark text-white"
                        >Bekijk</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <router-view v-else :key="'committee_' + $route.path" />
  </div>
</template>
<script>
export default {
  data() {
    return {
      committees: [],
      context: "",
    };
  },
  mounted() {
    if (this.$route.meta.Breadcrumb) {
      this.$store.commit("addBreadcrumb", {
        title: this.$route.meta.Breadcrumb,
        href: this.$route.path,
      });
    } else {
      this.$store.state.breadcrumbs = {
        title: "Commissies",
        links: [
          {
            title: !this.$route.matched.find((d) => d.name == "groups")
              ? "Commissies"
              : "Groepen",
            href: !this.$route.matched.find((d) => d.name == "groups")
              ? "/committees/3/all"
              : "/groups/2/all",
          },
        ],
      };
    }
  },
  created() {
    this.context = this.$route.name;
    var isCommittees = true;
    let itemLink = "committees";
    if (this.$route.matched.find((d) => d.name == "groups")) {
      isCommittees = false;
      itemLink = "groups";
    }
    var inner_sidebar_field = isCommittees ? "committees" : "groups";
    this.$store.state.inner_sidebar =
      this.$store.state.inner_sidebar_backup[inner_sidebar_field];

    this.$store.state.inner_sidebar_loader = true;
    if (this.$route.params.id) {
      this.$store
        .dispatch("get", "api/v1/committees/parent_id/" + this.$route.params.id)
        .then((data) => {
          // console.log(data);
          var committees = data.data.data;
          var menu = committees.map((comt) => {
            return {
              title: comt.title,
              href: "/" + itemLink + "/" + comt.id + "/view",
              children: [],
            };
          });

          menu = menu.sort((a, b) => (a.title > b.title && 1) || -1);
          this.$store.state.inner_sidebar = menu;
          this.$store.state.inner_sidebar_backup[inner_sidebar_field] = menu;
          this.$store.state.inner_sidebar_loader = false;
        })
        .catch((error) => {
          console.log(error);
          this.$store.state.inner_sidebar_loader = false;
        });
    } else {
      this.$store.state.inner_sidebar_loader = false;
    }
  },
  computed: {
    showContent() {
      return false;
    },
  },
};
</script>
 

<style scoped>
.nested-list {
  color: #6c6c6c;
  opacity: 1;
}

.card {
  background: #4192d9 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #0000004b;
  border-radius: 20px;
  padding: 0;
}

.no-gutters {
  background: #4192d9 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #0000004b;
  border-radius: 20px;
}

.card-footer {
  border-top: unset;
}
</style>
